/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React context
import { useSoftUIController, setLayout } from "context";
import { DashboardCardStyle } from "./styles";
import pxToRem from "assets/theme/functions/pxToRem";

function DashboardCardLayout({ sidebarState, children }) {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, hiddenSidenav, deviceStyle } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  if(sidebarState == 'hidden'){
    return <>{children}</>
  }

  return (
    <SoftBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        position: "relative",

        [breakpoints.up("xl")]: {
          marginLeft: hiddenSidenav ? pxToRem(120) : pxToRem(0),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      <SoftBox sx={(theme) => DashboardCardStyle(theme, { sidebarState, miniSidenav, hiddenSidenav, deviceStyle })}>
        <SoftBox m={{ xxs: sidebarState == 'sidenav' ? 1 : 0, xs: 3 }} height={{ xxs: '100%', xs: 'calc(100% - 48px)' }}> {/* w={{xxs: '100%', xs: 'calc(100% - 48px)'}} */}
          {children}
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props for the DashboardCardLayout
DashboardCardLayout.propTypes = {
  children: PropTypes.node.isRequired,
  sidebarState: PropTypes.string,
};

export default DashboardCardLayout;
